import React from "react";

function article_1() {
	return {
		date: "23 May 2023",
		title: "The Beauty of SwiftUI Modifiers",
		description:
			"Os modificadores são uma das principais ferramentas para criar visualizações personalizadas no SwiftUI. Eles permitem criar efeitos visuais, alterar a aparência de um objeto, adicionar transições e muito mais. Os modificadores podem ser empilhados para criar efeitos complexos e personalizados.",
		keywords: [
			"Luiz Sena Medium",
			"The Beauty of SwiftUI Modifiers",
			"Modifiers",
			"SwiftUI",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
				link: "https://medium.com/@senaluiz1307/swiftui-modifiers-87a0ef0a4545",
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">Content of article 1</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

// function article_2() {
// 	return {
// 		date: "7 May 2023",
// 		title: "Artificial Intelligence in Healthcare",
// 		description:
// 			"AI is transforming the healthcare industry, from improving patient outcomes to streamlining operations. Discover the latest applications of this game-changing technology.",
// 		style: ``,
// 		keywords: [
// 			"Artificial Intelligence in Healthcare",
// 			"Tharindu",
// 			"Tharindu N",
// 			"Tharindu Nayanajith",
// 		],
// 		body: (
// 			<React.Fragment>
// 				<h1>Content of article 2</h1>
// 			</React.Fragment>
// 		),
// 	};
// }

const myArticles = [article_1];

export default myArticles;
